export class MediaQuery {
  private constructor(public readonly value) {}

  public get matches() {
    return window.matchMedia(this.value).matches
  }

  static readonly onlyMobile = new MediaQuery('(max-width: 767px)')
  static readonly onlyMobileAndTablet = new MediaQuery('(max-width: 991px)')
  static readonly onlyTabletAndDesktop = new MediaQuery(
    '(min-width: 768px) and (max-width: 1023px)',
  )
  static readonly tablet = new MediaQuery('(min-width: 768px)')
  static readonly upToDesktop = new MediaQuery('(max-width: 1023px)')
  static readonly desktop = new MediaQuery('(min-width: 1024px)')
  static readonly upToLargeDesktop = new MediaQuery('(max-width: 1279px)')
  static readonly largeDesktop = new MediaQuery('(min-width: 1280px)')

  static readonly onlyScreen = new MediaQuery('screen')
}
